import {useMutation, useQueryClient} from '@tanstack/react-query';

import {QUERY__TOPIC_EVENTS} from '@entities/topic/queryKeys';
import {deleteEventGroup, DeleteEventGroupParams} from '../api';
import {QUERY__EVENT, QUERY__EVENTS} from '../queryKeys';

export const useDeleteEventGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: DeleteEventGroupParams) => deleteEventGroup(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({queryKey: [QUERY__EVENTS]});
      void queryClient.invalidateQueries({queryKey: [QUERY__EVENT]});
      void queryClient.invalidateQueries({queryKey: [QUERY__TOPIC_EVENTS]});
    },
  });
};
